import Chat from './chat';

export default Chat;